{
  "title": "How to Create or Join a Team",
  "description": "Create a new team in a competition, or join an existing one using an invite link from your team leader.",
  "headings": [
    "What You'll Accomplish",
    "Applies To",
    "Before You Start",
    "Steps",
    "What You'll See",
    "FAQ"
  ],
  "summary": "When you're done, you'll be a member of a team (the creator becomes the leader) and can start filling out registration and submission forms.",
  "roleNote": "Participant",
  "prerequisites": [
    "You've registered and verified your email",
    "The competition's registration period hasn't ended",
    "You aren't already on a team in this competition"
  ],
  "pathLabel": "Competition Detail Page → Team",
  "steps": [
    {
      "title": "1. Create a team",
      "description": "On the competition detail page, choose a category and click \"Create Team\", then enter a team name and submit; the creator automatically becomes the team leader. Any non-teacher account can belong to at most one team per competition."
    },
    {
      "title": "2. Generate an invite link (team leader)",
      "description": "The team leader can generate an invite link on the team page to share with prospective members, or invite by email instead, which sends a notification."
    },
    {
      "title": "3. Join a team (team member)",
      "description": "Clicking your leader's invite link first shows the competition, team, and inviter details; opening the link itself never adds you to the team. If you're not signed in yet, sign in or create an account first; you'll be brought back to the invitation page afterward. Once you've confirmed the details, choose \"Accept invitation and join\" to actually complete joining. If the link has expired, been revoked, or reached its use limit, the screen shows the specific reason and the leader needs to generate a new one; if you're already on another team in this competition, you must resolve that membership first before you can accept a different team's invitation."
    }
  ],
  "afterward": [
    "You appear in the team's member list",
    "The team leader can see all current members on the team page",
    "You can start filling out the registration and submission forms"
  ],
  "nextSteps": "Next, go to the registration form and fill in the information the competition requires.",
  "faq": [
    {
      "q": "Can I be on two teams at once?",
      "a": "No. In a given competition, a non-teacher account can hold at most one active team membership. If you need to switch teams, first check the status of your original team, or contact the organizer for help."
    },
    {
      "q": "Can only the team leader edit team information?",
      "a": "Editing team information (including generating invite links) requires being the team leader, or being staff for that competition with team-management permission granted. Regular members can view and collaborate on filling out forms, but cannot change the team's own settings."
    }
  ]
}
